import { render, staticRenderFns } from "./EditDrawers.vue?vue&type=template&id=4f88697a"
import script from "./EditDrawers.vue?vue&type=script&lang=js"
export * from "./EditDrawers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports